import React, { useState } from "react";
import cx from "classnames";
import MenuCloseIcon from "../../../assets/svgs/menu-close-icon.svg";
import MenuHamburgerIcon from "../../../assets/svgs/menu-hamburger-icon.svg";
import ZipmexLogo from "../../../assets/svgs/zipmex-logo.svg";
import MenuArrowIcon from "../../../assets/svgs/menu-arrow-next.svg";

import Link from "../../Link";

import {
  TradeMenu,
  EarnMenu,
  ExploreMenu,
  CampaignsMenu,
  CompanyMenu,
  SupportMenu,
  LearnMenu,
} from "../Menus/DesktopMenu";

import MobileMenu from "../Menus/MobileMenu";

import LanguageSwitcher from "../Menus/LanguageSwitcher";

import "./style.scss";
import SignUpButton from "../../SignUpButton";

const Header = (props) => {
  const { t, siteCountry, limeSignUpButton } = props;
  const latestPosts = JSON.parse(props.latestPosts);

  const [_menuPage, _setMenuPage] = useState(null);
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  const MAIN_MENUS = [
    {
      title: "trade",
      component: <TradeMenu isActive={true} siteCountry={siteCountry} />,
    },
    {
      title: "earn",
      component: <EarnMenu isActive={true} siteCountry={siteCountry} />,
    },
    ...(siteCountry === "th"
      ? [
          {
            title: "explore",
            component: <ExploreMenu isActive={true} />,
          },
        ]
      : []),
    {
      title: "campaigns",
      component: <CampaignsMenu isActive={true} />,
    },
    {
      title: "company",
      component: <CompanyMenu isActive={true} />,
    },
    {
      title: "support",
      component: <SupportMenu isActive={true} />,
    },
    {
      title: "learn",
      component: <LearnMenu isActive={true} latestPosts={latestPosts} />,
    },
  ];

  const _handleMobileMenuClick = () => {
    // prevent page from scrolling
    document.body.classList.toggle("stop-scrolling");

    if (isMenuOpened) {
      _setMenuPage(null);
    }

    setIsMenuOpened(!isMenuOpened);
  };

  const MobileNavBar = () => (
    <div className="d-flex align-items-center d-xl-none">
      <a
        href={`${t("common.exchangeLink")}/accounts/sign-in`}
        className="btn sign-up login"
      >
        {t("menu.btnLogin")}
      </a>
      <button
        id={`main-menu-hamburger`}
        className="main-menu navbar-toggler px-0 ml-2"
        type="button"
        onClick={() => _handleMobileMenuClick()}
      >
        <MenuCloseIcon
          className={cx({
            "d-block": isMenuOpened,
            "d-none": !isMenuOpened,
          })}
        />

        <MenuHamburgerIcon
          className={cx("hamburger-menu", {
            "d-none": isMenuOpened,
          })}
        />
      </button>
    </div>
  );
  const MobileMenuWrapper = () => (
    <div
      className={cx("collapse navbar-collapse sub-menu-hamburger", {
        "d-none": !isMenuOpened,
        "d-block": isMenuOpened,
      })}
      id={`sub-menu-hamburger`}
      aria-labelledby={`main-menu-hamburger`}
    >
      <MobileMenu
        menuPage={_menuPage}
        setMenuPage={_setMenuPage}
        latestPosts={latestPosts}
        siteCountry={siteCountry}
        t={t}
      />
    </div>
  );

  return (
    <>
      <nav
        id="navbar"
        className={cx(
          "navbar navbar-light bg-white fixed-top p-0",
          {
            opened: isMenuOpened,
          },
          { "h-100": isMenuOpened }
        )}
      >
        <div className="container flex-nowrap" id="navbar-container">
          <div className="main-menu-wrapper d-flex align-items-center my-2">
            <Link
              to="/"
              className="navbar-brand d-flex align-items-center mr-2 mr-xl-4"
            >
              <ZipmexLogo className="custom-logo" />
            </Link>
            {MAIN_MENUS.map((menu, i) => (
              <React.Fragment key={`main-menus-${i}`}>
                <div
                  key={`main-menu-${menu.title}-${i}`}
                  id={`main-menu-${menu.title}`}
                  className={cx("main-menu d-none d-xl-inline-block")}
                >
                  <div>{t(`menu.${menu.title}.title`)}</div>
                </div>

                <div
                  key={`sub-menu-${menu.title}-${i}`}
                  id={`sub-menu-${menu.title}`}
                  className={cx("sub-menu-container d-none")}
                  data-parent={`main-menu-${menu.title}`}
                >
                  {menu.component}
                </div>
              </React.Fragment>
            ))}
          </div>

          <MobileNavBar />

          <div className="d-none d-xl-flex my-2 align-items-center">
            <a
              href={`${t("common.exchangeLink")}/accounts/sign-in`}
              className="btn sign-up login mr-2"
            >
              {t("menu.btnLogin")}
            </a>
            {limeSignUpButton ? (
              <SignUpButton className="button-signup-lime">
                {t("menu.btnSignUp")}
                <MenuArrowIcon className="ml-2" />
              </SignUpButton>
            ) : (
              <SignUpButton className="btn btn-primary sign-up">
                {t("menu.btnSignUp")}
              </SignUpButton>
            )}
            <LanguageSwitcher />
          </div>
        </div>

        <MobileMenuWrapper />
      </nav>
    </>
  );
};

export default Header;
